/* ==========================================================================
   DEMONTHA — Sepet geliştirmeleri
   --------------------------------------------------------------------------
   YENİ DOSYA. Temanın mevcut sepet akışına DOKUNMAZ:
     · cart.js (CartItems / CartRemoveButton) ve cart-drawer.js
       (CartDrawerSection / CartDrawerItems) olduğu gibi çalışmaya devam eder.
     · Burada hiçbir tema custom element'i yeniden tanımlanmaz, hiçbir tema
       fonksiyonu monkey-patch'lenmez.
     · Tüm dinleyiciler `document` üzerinde delege edilir; çekmece yeniden
       render edildiğinde (innerHTML değişimi) yeniden bağlama gerekmez.

   Sağladıkları:
     1. Ürün kaldırınca "Geri al" (undo) bildirimi
     2. Adet değişikliklerinin ekran okuyucuya duyurulması (aria-live)
     3. Çekmece açıkken yüzen WhatsApp balonunun gizlenmesi (çakışma çözümü)
     4. Çapraz satış başlığının erişilebilir aç/kapa davranışı
     4b. Çapraz satış kartlarında kart içi varyant seçimi (çok varyantlı ürün)
     5. Çekmece kapalıyken içerideki bağlantıların sekme sırasından çıkarılması
   ========================================================================== */

(function () {
  'use strict';

  if (window.__dmtCartInit) return;
  window.__dmtCartInit = true;

  var STRINGS = Object.assign(
    {
      removed: 'sepetten kaldırıldı',
      undo: 'Geri al',
      undone: 'Ürün sepetinize geri eklendi.',
      undoError: 'Ürün geri eklenemedi. Lütfen tekrar deneyin.',
      dismiss: 'Bildirimi kapat',
      quantityUpdated: 'adedi güncellendi',
      crossAdded: 'sepete eklendi',
      crossAddError: 'Ürün sepete eklenemedi. Lütfen tekrar deneyin.',
      crossPickOpen: 'seçenekleri açıldı',
      crossPickClose: 'Seçimi kapat'
    },
    window.dmtCartStrings || {}
  );

  var TOAST_TIMEOUT = 9000;
  var toast = null;
  var toastTimer = null;
  var pendingUndo = null;
  var liveRegion = null;

  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------- utils */

  function cartRoutes() {
    return (window.routes || (window.Shopify && window.Shopify.routes) || {});
  }

  function isCartPage() {
    var url = cartRoutes().cart_url;
    return !!url && window.location.pathname === url;
  }

  function drawerEl() {
    return document.querySelector('cart-drawer');
  }

  function requestConfig(body) {
    if (typeof window.fetchConfig === 'function') {
      var cfg = window.fetchConfig('javascript');
      cfg.headers['Content-Type'] = 'application/json';
      cfg.headers.Accept = 'application/json';
      cfg.body = body;
      return cfg;
    }
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body
    };
  }

  /* ------------------------------------------------- erişilebilir duyuru */

  function ensureLiveRegion() {
    if (liveRegion && document.body.contains(liveRegion)) return liveRegion;
    liveRegion = document.createElement('p');
    liveRegion.className = 'visually-hidden';
    liveRegion.setAttribute('aria-live', 'polite');
    liveRegion.setAttribute('role', 'status');
    liveRegion.setAttribute('data-dmt-cart-live', '');
    document.body.appendChild(liveRegion);
    return liveRegion;
  }

  function announce(message) {
    if (!message) return;
    var region = ensureLiveRegion();
    region.textContent = '';
    window.setTimeout(function () {
      region.textContent = message;
    }, 60);
  }

  /* ------------------------------------------------------- undo bildirimi */

  function toastHost() {
    /* Çekmece varken bildirim <cart-drawer> içine monte edilir; böylece
       cart-drawer.js'in odak tuzağı (focus trap) "Geri al" butonunu da
       kapsar ve klavye kullanıcısı ona ulaşabilir. Çekmece #CartDrawer'ın
       İÇİ yeniden render edilir, <cart-drawer>'ın doğrudan çocukları değil —
       bu yüzden bildirim render'lardan sağ çıkar. */
    return drawerEl() || document.body;
  }

  function buildToast() {
    if (toast && toast.isConnected) return toast;

    toast = document.createElement('div');
    toast.className = 'dmt-cart-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.setAttribute('data-open', 'false');

    var text = document.createElement('span');
    text.className = 'dmt-cart-toast__text';
    text.setAttribute('data-dmt-toast-text', '');

    var undoBtn = document.createElement('button');
    undoBtn.type = 'button';
    undoBtn.className = 'dmt-cart-toast__undo';
    undoBtn.textContent = STRINGS.undo;
    undoBtn.addEventListener('click', onUndoClick);

    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'dmt-cart-toast__close';
    closeBtn.setAttribute('aria-label', STRINGS.dismiss);
    closeBtn.innerHTML =
      '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg>';
    closeBtn.addEventListener('click', hideToast);

    toast.appendChild(text);
    toast.appendChild(undoBtn);
    toast.appendChild(closeBtn);
    toastHost().appendChild(toast);

    return toast;
  }

  function showToast(message) {
    var el = buildToast();
    var text = el.querySelector('[data-dmt-toast-text]');
    if (text) text.textContent = message;
    el.setAttribute('data-open', 'true');

    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(hideToast, TOAST_TIMEOUT);
  }

  function hideToast() {
    window.clearTimeout(toastTimer);
    if (toast) toast.setAttribute('data-open', 'false');
    pendingUndo = null;
  }

  function snapshotRemoval(button) {
    var variantId = button.getAttribute('data-dmt-variant');
    if (!variantId) return null;

    var quantity = parseInt(button.getAttribute('data-dmt-quantity'), 10);
    var properties = null;
    var raw = button.getAttribute('data-dmt-properties');

    if (raw && raw !== 'null' && raw !== '{}') {
      try {
        properties = JSON.parse(raw);
      } catch (e) {
        properties = null;
      }
    }

    return {
      id: variantId,
      quantity: quantity > 0 ? quantity : 1,
      title: button.getAttribute('data-dmt-title') || '',
      sellingPlan: button.getAttribute('data-dmt-selling-plan') || '',
      properties: properties
    };
  }

  function onRemoveClick(event) {
    var button = event.target.closest && event.target.closest('cart-remove-button');
    if (!button) return;

    var snapshot = snapshotRemoval(button);
    if (!snapshot) return;

    pendingUndo = snapshot;
    var label = snapshot.title
      ? '“' + snapshot.title + '” ' + STRINGS.removed
      : STRINGS.removed;
    showToast(label);
  }

  function onUndoClick() {
    if (!pendingUndo) {
      hideToast();
      return;
    }

    var item = pendingUndo;
    var routes = cartRoutes();
    if (!routes.cart_add_url) {
      hideToast();
      return;
    }

    var line = { id: item.id, quantity: item.quantity };
    if (item.properties && Object.keys(item.properties).length) line.properties = item.properties;
    if (item.sellingPlan) line.selling_plan = item.sellingPlan;

    pendingUndo = null;

    fetch(routes.cart_add_url, requestConfig(JSON.stringify({ items: [line] })))
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (data && data.status && data.status !== 200) {
          announce(STRINGS.undoError);
          return;
        }
        hideToast();
        announce(STRINGS.undone);
        refreshCart();
      })
      .catch(function () {
        announce(STRINGS.undoError);
      });
  }

  /* ------------------------------------------------------- sepet yenileme */

  function refreshCart() {
    var drawer = drawerEl();

    if (drawer) {
      /* Temanın kendi yolu: CartDrawerSection 'cart-drawer:refresh' olayını
         dinler, bölümleri fetch eder ve #CartDrawer'ı yeniden yazar.
         PUB_SUB cartUpdate BİLEREK yayınlanmıyor — CartDrawerItems.onCartUpdate
         çekmece içeriğini /cart sayfası markup'ıyla değiştiriyor (tema hatası). */
      document.dispatchEvent(new CustomEvent('cart-drawer:refresh', { detail: { source: 'dmt-cart' } }));
      window.setTimeout(syncTabindex, 350);
      return;
    }

    refreshCartPageSections();
  }

  function refreshCartPageSections() {
    var itemsEl = document.getElementById('main-cart-items');
    var footerEl = document.getElementById('main-cart-footer');

    /* Sepet boşken main-cart-footer hiç basılmıyor. Bu durumda güvenli olan
       tam yenilemedir. */
    if (!itemsEl || !itemsEl.dataset.id || !footerEl || !footerEl.dataset.id) {
      window.location.reload();
      return;
    }

    var targets = [
      { section: itemsEl.dataset.id, root: itemsEl, selector: '.js-contents' },
      { section: footerEl.dataset.id, root: footerEl, selector: '.js-contents' }
    ];

    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble) targets.push({ section: 'cart-icon-bubble', root: bubble, selector: '.shopify-section' });

    var query = targets
      .map(function (t) {
        return t.section;
      })
      .join(',');

    fetch(window.location.pathname + '?sections=' + encodeURIComponent(query))
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        targets.forEach(function (t) {
          var html = data[t.section];
          if (!html) return;
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var source = parsed.querySelector(t.selector);
          var destination = t.root.querySelector(t.selector) || t.root;
          if (source && destination) destination.innerHTML = source.innerHTML;
        });
      })
      .catch(function () {
        window.location.reload();
      });
  }

  /* ------------------------------------------- adet değişikliği duyurusu */

  function onQuantityChange(event) {
    var input = event.target;
    if (!input || !input.classList || !input.classList.contains('js-counter-quantity')) return;

    var title = input.getAttribute('data-dmt-title') || '';
    var value = input.value;
    announce((title ? '“' + title + '” ' : '') + STRINGS.quantityUpdated + ': ' + value);
  }

  /* ------------------------------------ WhatsApp yüzen balonu / çakışma */

  var EXTRA_FLOAT_SELECTORS = [
    '[class*="whatsapp" i]',
    '[id*="whatsapp" i]',
    '[class*="wa-widget" i]',
    '[id*="wa-widget" i]',
    'iframe[src*="whatsapp" i]'
  ];

  var hiddenFloats = [];

  function collectFloatingWidgets() {
    var found = [];

    function addFixedAncestor(node) {
      var el = node;
      for (var i = 0; i < 6 && el && el !== document.body; i++) {
        var position = window.getComputedStyle(el).position;
        if (position === 'fixed' || position === 'sticky') {
          if (found.indexOf(el) === -1) found.push(el);
          return;
        }
        el = el.parentElement;
      }
    }

    document
      .querySelectorAll('a[href*="wa.me"], a[href*="api.whatsapp.com"], a[href^="whatsapp:"]')
      .forEach(addFixedAncestor);

    EXTRA_FLOAT_SELECTORS.forEach(function (selector) {
      var nodes;
      try {
        nodes = document.querySelectorAll(selector);
      } catch (e) {
        return;
      }
      nodes.forEach(function (el) {
        if (el.closest('cart-drawer')) return;
        if (window.getComputedStyle(el).position !== 'fixed') return;
        if (found.indexOf(el) === -1) found.push(el);
      });
    });

    return found;
  }

  function hideFloatingWidgets() {
    if (hiddenFloats.length) return;
    hiddenFloats = collectFloatingWidgets().map(function (el) {
      var previous = el.style.visibility;
      el.classList.add('dmt-cart-float-hidden');
      el.style.visibility = 'hidden';
      el.setAttribute('aria-hidden', 'true');
      return { el: el, previous: previous };
    });
  }

  function restoreFloatingWidgets() {
    hiddenFloats.forEach(function (entry) {
      entry.el.style.visibility = entry.previous || '';
      entry.el.classList.remove('dmt-cart-float-hidden');
      entry.el.removeAttribute('aria-hidden');
    });
    hiddenFloats = [];
  }

  /* --------------------------------------------------- sekme sırası (tab) */

  function syncTabindex() {
    var drawer = drawerEl();
    if (!drawer) return;

    var selectors = drawer.getAttribute('data-toggle-tabindex');
    if (!selectors) return;

    var value = drawer.hasAttribute('open') ? '0' : '-1';
    var nodes;
    try {
      nodes = drawer.querySelectorAll(selectors);
    } catch (e) {
      return;
    }
    nodes.forEach(function (el) {
      el.setAttribute('tabindex', value);
    });
  }

  /* ------------------------------------------------- çapraz satış aç/kapa */

  function onToggleClick(event) {
    var button = event.target.closest && event.target.closest('[data-dmt-toggle="cross-sell"]');
    if (!button) return;

    event.preventDefault();
    var block = button.closest('.wt-cart__cross-sell');
    if (!block) return;

    var collapsed = block.classList.toggle('wt-cart__cross-sell--collapsed');
    button.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
  }

  /* ----------------------------------- çapraz satış: sepete ekle (doğrudan)

     ÖLÇÜLEN HATA (2026-08-02, canlı önizleme, ADIM 1):
       Kartın sepet ikonu temanın <quick-add> özel elemanının içindeydi.
       quick-add.js tıklamada `.wt__quick-buy__container`ı açıyor — o panel
       position:fixed / z-index 100, sepet çekmecesi ise position:fixed /
       z-index 100000 ve İKİSİNİN DİKDÖRTGENİ AYNI (1420,0,500,1009).
       Sonuç: panel açılıyor ama çekmecenin altında kalıyor. Ölçüm:
         sepet 1 → 1 (ürün eklenmedi) · ekranda değişiklik yok ·
         body'ye `quick-buy-page-overlay` eklendi · odak çekmeceden çıkıp
         görünmeyen panelin .close-btn'ine geçti · konsolda 0 hata.
       Kullanıcının gördüğü: "tıklıyorum, hiçbir şey olmuyor".

     ÇÖZÜM: quick-buy paneli devreden tamamen çıktı. Düğme artık doğrudan
     /cart/add.js'e gidiyor ve çekmeceyi yerinde tazeliyor (refreshCart) —
     çekmece KAPANMIYOR. Yalnızca tek varyantlı ürünlerde düğme basılıyor
     (bkz. cart-cross-sell.liquid), yani yanlış varyant eklenmesi imkânsız. */

  /* Ekledikten sonra çekmece #CartDrawer'ın içini innerHTML ile yeniden
     yazıyor: basılan düğme DOM'dan siliniyor ve odak <body>'ye düşüyor.
     Fareyle tıklayan bunu fark etmez ama klavye kullanıcısı yerini kaybeder —
     sonraki Tab belgenin en başından devam eder.

     Yalnızca KLAVYEYLE tetiklendiğinde odak geri veriliyor. Ayrım
     `event.detail`: Enter/Space'in ürettiği click'te 0, fare tıklamasında ≥1.
     Fareyle tıklayanın odağını zorla taşımak istenmeyen bir sıçrama olurdu.

     Sabit bir setTimeout YETMİYOR: refreshCart bölümleri fetch ediyor ve
     yeniden basma süresi ağa bağlı. 500 ms'lik tek atış ölçümde dörtte bir
     oranında erken kalıyordu (odak <body>'de kalıyordu). Bunun yerine eski
     düğmenin DOM'dan kopması bekleniyor — yeniden basmanın bittiğinin kesin
     işareti bu. 2 sn içinde olmazsa vazgeçilir. */
  function restoreCrossFocus(oldButton, index) {
    var waited = 0;
    var timer = window.setInterval(function () {
      waited += 100;
      var reRendered = !document.body.contains(oldButton);
      if (!reRendered && waited < 2000) return;
      window.clearInterval(timer);

      var root = document.querySelector('[data-dmt-xsell]');
      if (!root) return;
      /* İndeks KART düzeyindeki düğmeler üzerinden sayılıyor
         (`[data-dmt-cross-cta]`), seçim katmanındaki varyant düğmeleri
         üzerinden değil: bir kartta 22 seçenek olabiliyor, `[data-dmt-xsell-add]`
         ile saymak indeksi tamamen kaydırırdı. */
      var buttons = root.querySelectorAll('[data-dmt-cross-cta]');
      var target = buttons[Math.min(index, buttons.length - 1)];
      if (!target) target = root.querySelector('.dmt-cart__cross-link');
      if (target && typeof target.focus === 'function') target.focus();
    }, 100);
  }

  function onCrossAddClick(event) {
    var button = event.target.closest && event.target.closest('[data-dmt-xsell-add]');
    if (!button) return;

    var viaKeyboard = event.detail === 0;
    var root = button.closest('[data-dmt-xsell]');
    /* Odak geri yükleme kart düzeyinde yapılır: seçim katmanından eklendiğinde
       katman kapanır, geri dönülecek yer o kartın sepet ikonudur. */
    var card = button.closest('.dmt-cart__cross-card');
    var cta = (card && card.querySelector('[data-dmt-cross-cta]')) || button;
    var index = root
      ? Array.prototype.indexOf.call(root.querySelectorAll('[data-dmt-cross-cta]'), cta)
      : 0;
    if (index < 0) index = 0;

    /* Düğme, kartı kaplayan stretched link'in KARDEŞİ — tıklama bağlantıdan
       geçmiyor, bu yüzden gezinmeyi iptal etmeye gerek yok. preventDefault
       yalnızca <button>'ın olası varsayılan davranışını kesmek için. */
    event.preventDefault();

    if (button.getAttribute('aria-busy') === 'true') return;

    var variantId = button.getAttribute('data-dmt-variant');
    var title = button.getAttribute('data-dmt-title') || '';
    var routes = cartRoutes();
    if (!variantId || !routes.cart_add_url) return;

    button.setAttribute('aria-busy', 'true');
    button.disabled = true;

    function release() {
      button.removeAttribute('aria-busy');
      button.disabled = false;
    }

    fetch(routes.cart_add_url, requestConfig(JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })))
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (data && data.status && data.status !== 200) {
          release();
          announce(STRINGS.crossAddError);
          return;
        }
        /* Kısa görsel onay. Çekmece hemen tazelenince kart zaten listeden
           düşüyor ("sepette zaten var" filtresi), ama tazeleme gelene kadar
           kullanıcı bir şey olduğunu görmeli. */
        /* Seçim katmanından eklendiyse katman kapanır; basılan düğme artık
           görünmediği için onay, kartın görünen sepet ikonunda gösterilir. */
        var panel = button.closest('[data-dmt-pick-panel]');
        if (panel) {
          closePicker(panel, false);
          cta.setAttribute('data-dmt-added', 'true');
        } else {
          button.setAttribute('data-dmt-added', 'true');
        }
        announce((title ? '“' + title + '” ' : '') + STRINGS.crossAdded);
        refreshCart();
        if (viaKeyboard) restoreCrossFocus(button, index);
        window.setTimeout(release, 1200);
      })
      .catch(function () {
        release();
        announce(STRINGS.crossAddError);
      });
  }

  /* ------------------------------- çapraz satış: kart içi varyant seçimi

     NEDEN: sepet ikonu yalnızca TEK VARYANTLI üründe basılıyordu (katalogda
     250 üründen 99'u çok varyantlı) — kartların bir kısmında ikon vardı, bir
     kısmında yoktu. Kullanıcı bunu tutarsızlık olarak bildirdi. Kartı ürün
     sayfasına göndermek çözüm değil: müşteri ödemeye en yakın olduğu anda
     akıştan çıkar.

     ÇÖZÜM: ikon artık her uygun kartta. Çok varyantlıda tıklama sepete
     eklemez, kartın İÇİNDEKİ seçim katmanını açar; seçim yapılınca ekleme
     aynı onCrossAddClick akışından geçer. Sayfadan çıkış / yönlendirme yok.

     ODAK TUZAĞI KURULMUYOR (bilerek): katman kartın içinde duran normal bir
     kutu, modal değil. Tab doğal sırayla ilerler, Esc kapatır ve odağı açan
     düğmeye geri verir. Eski <quick-add> yoluna (görünmez panel + Tab hapsi)
     DÖNÜLMEDİ.                                                              */

  function pickPanelOf(toggle) {
    var id = toggle.getAttribute('data-dmt-pick-target');
    return id ? document.getElementById(id) : null;
  }

  function pickToggleOf(panel) {
    if (!panel || !panel.id) return null;
    return document.querySelector('[data-dmt-pick-target="' + panel.id + '"]');
  }

  function closePicker(panel, refocus) {
    if (!panel || panel.hidden) return;
    panel.hidden = true;
    var toggle = pickToggleOf(panel);
    if (!toggle) return;
    toggle.setAttribute('aria-expanded', 'false');
    if (refocus && typeof toggle.focus === 'function') toggle.focus();
  }

  function closeAllPickers(except) {
    var panels = document.querySelectorAll('[data-dmt-pick-panel]');
    Array.prototype.forEach.call(panels, function (panel) {
      if (panel !== except) closePicker(panel, false);
    });
  }

  function onCrossPickClick(event) {
    if (!event.target.closest) return;

    var toggle = event.target.closest('[data-dmt-xsell-pick]');
    if (toggle) {
      event.preventDefault();
      var panel = pickPanelOf(toggle);
      if (!panel) return;
      if (!panel.hidden) {
        closePicker(panel, true);
        return;
      }
      closeAllPickers(panel);
      panel.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      announce((toggle.getAttribute('data-dmt-title') || '') + ' ' + STRINGS.crossPickOpen);
      /* Odak ilk SEÇİLEBİLİR seçeneğe: tükenmiş varyant `disabled`, oraya
         odak vermek klavye kullanıcısını çıkmaza sokardı. */
      var first = panel.querySelector('[data-dmt-pick-opt]:not([disabled])');
      if (first && typeof first.focus === 'function') first.focus();
      return;
    }

    var closeBtn = event.target.closest('[data-dmt-pick-close]');
    if (closeBtn) {
      event.preventDefault();
      closePicker(closeBtn.closest('[data-dmt-pick-panel]'), true);
      return;
    }

    /* Dışarı tıklama kapatır. Katmanın İÇİNE yapılan tıklamalar (varyant
       seçimi dahil) muaf. Odak taşınmaz: fareyle başka yere tıklayan
       kullanıcının odağını sıçratmak istenmeyen bir davranış olurdu. */
    if (!event.target.closest('[data-dmt-pick-panel]')) closeAllPickers(null);
  }

  function onPickKeydown(event) {
    if (event.key !== 'Escape' && event.key !== 'Esc') return;
    if (!event.target.closest) return;

    var panel = event.target.closest('[data-dmt-pick-panel]');
    if (!panel) {
      var toggle = event.target.closest('[data-dmt-xsell-pick]');
      panel = toggle ? pickPanelOf(toggle) : null;
    }
    if (!panel || panel.hidden) return;

    /* Çekmecenin kendi Esc dinleyicisi çekmeceyi kapatıyor. Katman açıkken
       Esc önce KATMANI kapatmalı — bu yüzden capture aşamasında dinleniyor
       ve olay burada durduruluyor. */
    event.stopPropagation();
    event.preventDefault();
    closePicker(panel, true);
  }

  /* ------------------------------------ çapraz satış: Shopify öneri katmanı

     Sunucu, snippets/cart-cross-sell.liquid'in KURAL TABANLI listesini zaten
     basmış durumda (ekranda boşluk yok). Burada yalnızca bir yükseltme
     denenir: Shopify'ın "complementary" önerisi merchant tarafından Search &
     Discovery ile küratörlenmişse o liste daha iyidir, onunla değiştirilir.

     Boş/hatalı yanıt sessizce yok sayılır — kural tabanlı liste yerinde kalır.
     Her çapa (anchor) ürün için en fazla bir istek atılır; çekmece yeniden
     basıldığında aynı çapa için tekrar istek yapılmaz.                       */

  var XSELL_SECTION = 'dmt-cart-cross-sell';
  var xsellTried = {};

  function upgradeCrossSell() {
    var root = document.querySelector('[data-dmt-xsell]');
    if (!root) return;

    var source = root.getAttribute('data-dmt-xsell-source');
    /* manual = merchant elle ürün seçmiş (P0), ezilmez.
       recommendations = zaten yükseltilmiş. */
    if (source === 'manual' || source === 'recommendations') return;

    var anchor = root.getAttribute('data-dmt-xsell-anchor');
    if (!anchor) return;

    /* Önbellek "istek atıldı mı"yı değil "bu çapa için sonuç ne çıktı"yı tutar:
       çekmece her sepet güncellemesinde yeniden basılıyor ve sunucu yine kural
       tabanlı listeyi veriyor — boş dönen bir çapa için tekrar tekrar istek
       atmanın anlamı yok. */
    if (xsellTried[anchor] === 'pending' || xsellTried[anchor] === 'empty') return;

    var base = cartRoutes().product_recommendations_url || '/recommendations/products';
    var url =
      base +
      (base.indexOf('?') === -1 ? '?' : '&') +
      'section_id=' + encodeURIComponent(XSELL_SECTION) +
      '&product_id=' + encodeURIComponent(anchor) +
      '&intent=complementary&limit=10';

    xsellTried[anchor] = 'pending';

    fetch(url)
      .then(function (response) {
        return response.ok ? response.text() : '';
      })
      .then(function (html) {
        if (!html) {
          xsellTried[anchor] = 'empty';
          return;
        }
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector('[data-dmt-xsell]');
        /* Snippet öneri listesi boşsa kural tablosuna düşer; o zaman
           kaynak "recommendations" olmaz ve değiştirmeye değmez. */
        if (!fresh || fresh.getAttribute('data-dmt-xsell-source') !== 'recommendations') {
          xsellTried[anchor] = 'empty';
          return;
        }
        var current = document.querySelector('[data-dmt-xsell]');
        if (!current || !current.parentNode) {
          xsellTried[anchor] = 'empty';
          return;
        }
        current.parentNode.replaceChild(fresh, current);
        xsellTried[anchor] = 'done';
        syncTabindex();
      })
      .catch(function () {
        xsellTried[anchor] = 'empty';
      });
  }

  /* ----------------------------------------------------------------- init */

  function observeDrawerState() {
    var body = document.body;
    if (!body || typeof MutationObserver !== 'function') return;

    var wasOpen = body.classList.contains('page-overlay-cart-on');

    new MutationObserver(function () {
      var isOpen = body.classList.contains('page-overlay-cart-on');
      if (isOpen === wasOpen) return;
      wasOpen = isOpen;

      if (isOpen) {
        hideFloatingWidgets();
      } else {
        restoreFloatingWidgets();
        hideToast();
        /* Çekmece kapanırken açık kalan bir katmanın düğmeleri görünmez
           olmasına rağmen Tab sırasında kalırdı. */
        closeAllPickers(null);
      }
      syncTabindex();
    }).observe(body, { attributes: true, attributeFilter: ['class'] });

    var drawer = drawerEl();
    if (drawer) {
      var pending = null;
      new MutationObserver(function () {
        window.clearTimeout(pending);
        pending = window.setTimeout(function () {
          syncTabindex();
          upgradeCrossSell();
        }, 120);
      }).observe(drawer, { childList: true, subtree: true });
    }
  }

  function init() {
    /* Kaldır butonu tema dinleyicisinden ÖNCE okunmalı (capture) — satır
       DOM'dan silinmeden önce varyant/adet bilgisini alıyoruz. */
    document.addEventListener('click', onRemoveClick, true);
    document.addEventListener('click', onToggleClick);
    /* Delege: çekmece her sepet güncellemesinde innerHTML ile yeniden
       basılıyor; kart düğmelerine tek tek bağlanmak yeniden bağlama sorunu
       doğururdu (eski <quick-add> yolunun bir başka kırılganlığı). */
    document.addEventListener('click', onCrossAddClick);
    /* SIRA ÖNEMLİ: onCrossAddClick önce çalışır. onCrossPickClick'in
       "dışarı tıklama" dalı, katmanın içindeki varyant düğmelerini muaf
       tutuyor; ekleme ile kapatma birbirini kesmiyor. */
    document.addEventListener('click', onCrossPickClick);
    /* Capture: çekmecenin Esc dinleyicisinden ÖNCE çalışmalı. */
    document.addEventListener('keydown', onPickKeydown, true);
    document.addEventListener('change', onQuantityChange);

    if (isCartPage()) {
      /* /cart sayfasında çekmece yok; balon gizlenemez, bunun yerine CSS
         ödeme butonunun altına güvenlik payı bırakıyor. */
      return;
    }

    observeDrawerState();
    syncTabindex();
    upgradeCrossSell();

    if (reduceMotion) {
      document.documentElement.setAttribute('data-dmt-reduce-motion', 'true');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
